import "core-js/modules/es6.promise";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.number.constructor";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import ApiService from '../../../services/apiService';
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import { validImageFileName, readableFileSizeFromBytes as readableFileSizeUtil } from '../../../utils/vuex';
import { getFileURL } from '../../../utils/file-uploads';
export default {
  name: 'CoreDtwinAttachmentsItem',
  props: {
    source: {
      type: String,
      default: 'digitaltwin'
    },
    item: {
      type: [Object, File],
      required: true
    },
    isQueued: {
      type: Boolean,
      default: false
    },
    deletable: {
      type: Boolean,
      default: true
    },
    selectable: {
      type: Boolean,
      default: false
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    isImage: {
      type: Boolean,
      default: false
    },
    apiVersion: {
      type: Number,
      default: 1,
      required: false
    }
  },
  data: function data() {
    return {
      messages: {
        error: 'meh meh meh, an occurance has errored.'
      },
      uploadProgress: 0,
      removing: false,
      itemIsSelected: false
    };
  },
  computed: _objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])),
  watch: {
    isSelected: function isSelected() {
      this.itemIsSelected = this.isSelected;
    }
  },
  created: function created() {
    if (this.item.file) {
      this.uploadAttachment(this.item.file);
    }

    this.itemIsSelected = this.isSelected;
  },
  methods: {
    readableFileSizeFromBytes: readableFileSizeUtil,
    getAttachmentDownloadUrl: function getAttachmentDownloadUrl(file) {
      if (this.source === 'devicetype') {
        if (/^http(?:s):\/\//i.test(file.storagePath)) {
          return file.storagePath;
        }

        return "".concat(process.env.VUE_APP_N1_API_PROTOCOL, "://").concat(process.env.VUE_APP_N1_API_HOST).concat(file.storagePath);
      }

      return getFileURL(file.id, this.apiVersion);
    },
    previewAttachment: function previewAttachment(fileId) {
      this.$emit('item:preview', this.getAttachmentDownloadUrl(fileId));
    },
    isPreviewable: function isPreviewable(fileName) {
      return validImageFileName(fileName);
    },
    deleteAttachment: function deleteAttachment(file) {
      this.removing = true;
      this.$emit('item:remove', file);
    },
    uploadAttachment: function () {
      var _uploadAttachment = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(file) {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.formData = new FormData();
                this.formData.append('file', file);
                _context.prev = 2;

                if (!(this.source === 'devicetype')) {
                  _context.next = 9;
                  break;
                }

                _context.next = 6;
                return NiotaClassicApiService.uploadImage(file, 'devicetype', this.onProgressHandler);

              case 6:
                result = _context.sent;
                _context.next = 12;
                break;

              case 9:
                _context.next = 11;
                return ApiService.saveAttachment(this, this.formData, this.onProgressHandler, this.apiVersion);

              case 11:
                result = _context.sent;

              case 12:
                this.$emit('item:update', {
                  fileId: result.fileId || result.files[0],
                  item: this.item
                });
                _context.next = 20;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](2);
                console.error(_context.t0);
                this.$emit('item:update', null);

                if (_context.t0.response && this.$i18n_t("Error.".concat(_context.t0.response.data.message))) {
                  this.$snack(this.$i18n_t("Error.".concat(_context.t0.response.data.message)), 'error');
                } else {
                  this.$snack(this.$i18n_t('DigitalTwin.DigitalTwin.attachmentErrorUpload'), 'error');
                }

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 15]]);
      }));

      function uploadAttachment(_x) {
        return _uploadAttachment.apply(this, arguments);
      }

      return uploadAttachment;
    }(),
    onProgressHandler: function onProgressHandler(progressEvent) {
      this.uploadProgress = Math.round(progressEvent.loaded / progressEvent.total * 100);
    }
  }
};